import { globalsTypes } from "../types/types"


export const resetAll = () => ({
    type: globalsTypes.resetAll,
}); 